<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { modulesName } from '@/store';
import loading from '@quisit/mipe-utils/mixins/loading';

export default {
  name: 'App',
  mixins: [loading],
  computed: {
    ...mapState(modulesName.appModuleName, ['loading']),
  },
  watch: {
    loading: {
      immediate: true,
      handler(val) {
        val === true ? this.ShowWait() : this.HideWait();
      },
    },
  },
  created() {
    if (
      window.location.protocol !== 'https:' &&
      window.location.href.indexOf('localhost') < 0
    ) {
      window.location.replace(window.location.href.replace('http:', 'https:'));
    }
  },
};
</script>
